import React, { useState } from 'react';
import { IonIcon, IonInput, IonButton, IonLabel } from '@ionic/react';
import { eyeOutline, eyeOffOutline } from 'ionicons/icons';
import './index.css';

const PasswordInput = ({ value: propValue, label, labelColor, onIonChange, ...rest }) => {
  const [value, setValue] = useState(propValue || '');
  const [show, setShow] = useState(false);

  const togglePass = (show) => {
    setShow(show);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onIonChange) {
      onIonChange(e);
    }
  };

  return (
    <div className="okx-password-wrapper">
      <div className="okx-password-holder">
        {label && (
          <IonLabel position="floating" color={labelColor}>
            {label}
          </IonLabel>
        )}
        <IonInput
          {...rest}
          className="okx-password"
          type={show ? 'text' : 'password'}
          pattern="password"
          value={value}
          onIonInput={handleChange}
          onIonBlur={handleChange}
        />
      </div>

        <IonIcon
        disabled={value === ''}
        fill="clear"
        size="small"
        onTouchStart={() => togglePass(true)}
        onTouchEnd={() => togglePass(false)}
        onMouseDown={() => togglePass(true)}
        onMouseUp={() => togglePass(false)}
        
        style={{height:'20px',width:'20px'}} slot='end' icon={show ? eyeOutline : eyeOffOutline} />
    </div>
  );
};

export default PasswordInput;
